import * as React from "react";
import { forwardRef } from "react";
const SvgNotificationIconSuccess = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("g", { style: {
  stroke: "#27d397",
  strokeWidth: 2,
  fill: "none"
} }, /* @__PURE__ */ React.createElement("circle", { cx: 12, cy: 12, r: 12, style: {
  stroke: "none"
} }), /* @__PURE__ */ React.createElement("circle", { cx: 12, cy: 12, r: 11, style: {
  fill: "none"
} })), /* @__PURE__ */ React.createElement("path", { d: "M11.089 14.518a1.187 1.187 0 0 0-1.672 0l-4.256 4.256-1.842-1.841A1.182 1.182 0 1 0 1.646 18.6l2.678 2.678a1.183 1.183 0 0 0 1.672 0l5.091-5.093a1.183 1.183 0 0 0 0-1.672z", transform: "translate(5.7 -5.773)", style: {
  fill: "#27d397"
} }));
const ForwardRef = forwardRef(SvgNotificationIconSuccess);
export { ForwardRef as ReactComponent };
